export enum AreaDesignation {
  General = "General",
  Bath = "Bath",
  HalfBath = "HalfBath",
  Kitchen = "Kitchen",
  Bedroom = "Bedroom",
  Utility = "Utility",
  Garage = "Garage",
}
